/** Unknown outcomes keep the original submit key frozen until reconciliation. */
export function validDistributorOrderReceipt(result) {
  return (
    /^[a-f\d]{24}$/i.test(result?._id) &&
    /^ORD-\d{4}-\d{4,}$/.test(result.orderId) &&
    ['submitted', 'approved', 'shipped', 'completed', 'cancelled'].includes(result.status) &&
    ['processing', 'pending', 'sent', 'needs_review', 'cancelled'].includes(
      result.deliveryStatus
    ) &&
    (result.status === 'submitted') === (result.deliveryStatus === 'processing') &&
    (result.status === 'cancelled') === (result.deliveryStatus === 'cancelled')
  );
}

export function distributorOrderNotice(result) {
  return result.status === 'submitted'
    ? 'Order received \u2014 processing'
    : {
        key: '{orderId} {status}. BLS delivery: {deliveryStatus}.',
        values: {
          orderId: result.orderId,
          status: result.status,
          deliveryStatus: result.deliveryStatus,
        },
      };
}
